import { CalendarEvent } from 'owa-calendar-types';
import { getOpxHostApi } from 'owa-opx';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { updateOpxRoomFinderData } from '../actions/calendarRoomActions';
import showRoomPanel from '../actions/showRoomPanel';
import { OpxRoomFinderData } from '../store/schema/RoomPanelOpxTypes';
import { convertOpxEvent } from '../utils/convertOpxEvent';

export async function initializeOpxData() {
    if (isHostAppFeatureEnabled('scenarioData')) {
        // initialize the OPX host API
        const opxHostApi = getOpxHostApi();

        // host app provides the initial data for room panel, which is added to store
        const opxRoomFinderData: OpxRoomFinderData = await opxHostApi.getScenarioData();
        updateOpxRoomFinderData(opxRoomFinderData);

        // OPX component registers the handler for acting on new data passed by host app over time
        opxHostApi.registerScenarioDataUpdatedHandler(updateOpxRoomFinderData);

        // initialize free-busy cache and room list
        showRoomPanel(
            // ideally the CalendarEvent type-cast could be dropped at some point after cleaning up downstream type expectations
            convertOpxEvent(opxRoomFinderData.event) as CalendarEvent,
            false /* isConsumer */,
            true /** isDeepLink */
        );
    }
}
